import ProviderAccount from '~/types/ProviderAccount';
import { ActionKeys } from './constants';

function fetchServiceLevelsByAccount() {
  return <const>{
    type: ActionKeys.FETCH_SERVICE_LEVELS_BY_ACCOUNT,
  };
}

function fetchServiceLevelsByAccountSuccess(providerAccounts: ProviderAccount[]) {
  return <const>{
    type: ActionKeys.FETCH_SERVICE_LEVELS_BY_ACCOUNT_SUCCESS,
    payload: {
      providerAccounts,
    },
  };
}

function fetchServiceLevelsByAccountError(errorMessage: string) {
  return <const>{
    type: ActionKeys.FETCH_SERVICE_LEVELS_BY_ACCOUNT_ERROR,
    payload: {
      errorMessage,
    },
  };
}

export {
  fetchServiceLevelsByAccount,
  fetchServiceLevelsByAccountSuccess,
  fetchServiceLevelsByAccountError,
};

export type ProvidersActions =
  | ReturnType<typeof fetchServiceLevelsByAccount>
  | ReturnType<typeof fetchServiceLevelsByAccountSuccess>
  | ReturnType<typeof fetchServiceLevelsByAccountError>;
